import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ModalDialogService } from '../../modal-dialog/modal-dialog.service';
import { GlobalNotificationConfirmPopupComponent, GlobalNotificationConfirmInput } from './global-notification-confirm-popup.component';

@NgModule({
  declarations: [
    GlobalNotificationConfirmPopupComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule
  ],
  providers: [
    ModalDialogService<boolean, GlobalNotificationConfirmInput>
  ],
  exports: [
    GlobalNotificationConfirmPopupComponent
  ]
})
export class GlobalNotificationConfirmPopupModule { }
